import {IsTestBookedForm} from '../../../fields/testing/types'

export const buildIsTestBookedForm = (): IsTestBookedForm => {
  return {
    isTestBooked: false
  }
}
